import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/settings/licenseRenewalSetupFee/main"));


const LicenseRenewalSetUpFee = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>

        
    
  );
};

export default LicenseRenewalSetUpFee;




